import { Component, OnInit } from '@angular/core';
import { IntroductionMessages } from 'src/app/modules/shared/models/component-messages/introduction-messages';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-stepper-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss']
})
export class IntroductionComponent implements OnInit {

  public introductionMessages = new IntroductionMessages();

  constructor(
    //appel du constructor AutoCompleteService pour initialisation des listes cpv, nuts etc
    private autoCompleteService: AutoCompleteService,
    private titleService:Title
    ) {}

  public ngOnInit() {
    this.titleService.setTitle('Avis de publicité - Créer un avis de publicité');  
  }
}
